module.exports = __webpack_public_path__ + "img/map.13e1bb18.svg";